export default "__VITE_ASSET__D_j9vEpZ__"